// @ts-check

/**
 * @module network/NetworkError
 */

/** Class representing a network error */
export default class NetworkError extends Error {
    /**
     * Create a NetworkError
     * @param {string} message - Error description (inherited from Error)
     * @param {Object} response - HTTP response object
     */
    constructor(
        message,
        response
    ) {
        super(message);

        this.response = response;
    }
};
